import { ITransactionStatusRequest } from '../qa-tools-service/qa-tools.interface';

export const TRANSACTION_STATUSES: ITransactionStatusRequest[] = [
  { resSt: 17, resStDes: 'Buyer_QuotaFull', quantity: 1 },
  { resSt: 21, resStDes: 'Complete', quantity: 1 },
  { resSt: 42, resStDes: 'PS_BlackList_Fail', quantity: 1 },
];

export const QUANTITY_OPTIONS = [0, 5, 10, 15, 20, 25];
